(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["limitless-coa-library"] && !Shopify.designMode) return;
  try {
    
function bindLimitlessCoa(){
 document.querySelectorAll('[data-coa-library]').forEach(root=>{
  if(root.dataset.bound)return;root.dataset.bound='true';
  const search=root.querySelector('[data-coa-search]');const filter=root.querySelector('[data-coa-filter]');const cards=[...root.querySelectorAll('[data-coa-card]')];
  const normalize=value=>value.toLowerCase().replace(/[^a-z0-9]/g,'');
  const update=()=>{const term=normalize(search.value);let count=0;cards.forEach(card=>{card.hidden=!(normalize(card.dataset.search).includes(term)&&(!filter.value||card.dataset.compound===filter.value));if(!card.hidden)count++;});root.querySelector('[data-coa-count]').textContent=count;root.querySelector('[data-coa-empty]').hidden=count!==0;};
  search.addEventListener('input',update);filter.addEventListener('change',update);root.querySelector('[data-coa-clear]').addEventListener('click',()=>{search.value='';filter.value='';update();search.focus();});
  cards.forEach(card=>{const zoom=card.querySelector('[data-coa-zoom]');const scroller=card.querySelector('.lb-coa-image-scroll');zoom.addEventListener('click',()=>{const enlarged=scroller.classList.toggle('is-enlarged');zoom.setAttribute('aria-pressed',String(enlarged));zoom.textContent=enlarged?zoom.dataset.fit:zoom.dataset.enlarge;scroller.scrollLeft=enlarged?(scroller.scrollWidth-scroller.clientWidth)/2:0;});const image=card.querySelector('img');image.addEventListener('contextmenu',event=>event.preventDefault());image.addEventListener('dragstart',event=>event.preventDefault());});
  const openLinked=()=>{const url=new URL(location.href);let target='';try{target=decodeURIComponent(url.hash.slice(1));}catch{return;}if(!target&&url.searchParams.get('report'))target='coa-'+url.searchParams.get('report');const card=cards.find(item=>item.id===target);if(card){search.value='';filter.value='';update();card.open=true;requestAnimationFrame(()=>card.scrollIntoView({block:'start'}));}};
  window.addEventListener('hashchange',openLinked);openLinked();
 });
}
bindLimitlessCoa();document.addEventListener('shopify:section:load',bindLimitlessCoa);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["limitless-product-conversion"] && !Shopify.designMode) return;
  try {
    
function bindLimitlessProducts(){document.querySelectorAll('[data-lb-product]').forEach(root=>{if(root.dataset.bound)return;root.dataset.bound='true';const select=root.querySelector('[data-lb-variant]');const update=()=>{const option=select.options[select.selectedIndex];const available=option.dataset.available==='true';root.querySelector('[data-lb-price]').textContent=option.dataset.price;const button=root.querySelector('[data-lb-add]');button.disabled=!available;button.textContent=root.querySelector(available?'[data-lb-label-add]':'[data-lb-label-sold]').textContent;root.querySelector('[data-lb-stock]').textContent=root.querySelector(available?'[data-lb-label-available]':'[data-lb-label-unavailable]').textContent;let hasCoa=false;root.querySelectorAll('[data-lb-coa-variant]').forEach(item=>{item.hidden=item.dataset.lbCoaVariant!==option.value;if(!item.hidden)hasCoa=true;});const missingCoa=root.querySelector('[data-lb-coa-missing]');if(missingCoa)missingCoa.hidden=hasCoa;const url=new URL(window.location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);};select.addEventListener('change',update);});}
bindLimitlessProducts();document.addEventListener('shopify:section:load',bindLimitlessProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
